import React, { Component } from 'react';
import { Row, Col, FormGroup, Radio } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import getContent from './Contents/CureRemedies';
import Select from '../Select';

export default class CureRemedies extends Component {
  options = () => ({
    field1: this.props.field1,
    field2: this.props.field2,
    field3: this.props.field3,
  });

  handleContent(field, index) {
    const { block, agreement } = this.props;

    const options = this.options();
    options[field] = index;

    // if (field === 'field1' && index === 1) {
    //     options['field3'] = undefined;
    // }

    this.props.updateBlock(
      block.id,
      getContent(options, agreement.type),
      options
    );
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          <Col sm={12}>
            <p className="question">
              If a collaborator breaches this agreement, should they have a
              chance to fix the breach before they can be sued?
            </p>
            <FormGroup className="answer">
              <Radio
                name="cure-field1"
                checked={this.props.field1 === 0}
                readOnly
                onClick={(e) => this.handleContent('field1', 0)}
              >
                Yes, there should be a window of
                <Select
                  className="select-mini"
                  value={this.props.field3}
                  onChange={(e) => this.handleContent('field3', e.target.value)}
                >
                  <option value="">Select Date</option>
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="30">30</option>
                </Select>
                days for the collaborator to fix (cure) the breach.
              </Radio>
              <Radio
                name="cure-field1"
                checked={this.props.field1 === 1}
                readOnly
                onClick={(e) => this.handleContent('field1', 1)}
              >
                No, a notice and cure period is not required before rights under
                this agreement can be enforced.
              </Radio>
            </FormGroup>
            {this.props.agreement.type === 'premium' ? (
              <div>
                <p className="question">
                  Should collaborators be able to seek other forms of remedies
                  besides monetary damages, such as injunctions, specific
                  actions, rescission, restitution etc. (equitable relief)?
                </p>
                <FormGroup className="answer">
                  <Radio
                    name="cure-field2"
                    checked={this.props.field2 === 0}
                    readOnly
                    onClick={(e) => this.handleContent('field2', 0)}
                  >
                    No. Only monetary damages can be pursued.
                  </Radio>
                  <Radio
                    name="cure-field2"
                    checked={this.props.field2 === 1}
                    readOnly
                    onClick={(e) => this.handleContent('field2', 1)}
                  >
                    Yes. Collaborators should be able to seek injunctive relief,
                    in addition to other remedies available to them like
                    monetary damages.
                  </Radio>
                </FormGroup>
              </div>
            ) : null}
          </Col>

          <Col sm={12}>{this.props.children}</Col>

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  Things can go wrong. When this happens, this clause provides
                  guidelines for how long a collaborator at fault has to fix the
                  problem. If the problem is not fixed, this clause provides
                  guidelines for the actions/recourse that collaborators who are
                  not at fault can take.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is a "breach"?</p>
                <p className="small">
                  A breach is the failure of a collaborator to perform/practice
                  the obligations that were agreed to.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is a "cure"?</p>
                <p className="small">
                  A cure is a remedy to a breach. It is the opportunity for the
                  collaborator who has breached the agreement to fix the
                  problem.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is a "remedy"?</p>
                <p className="small">
                  A "remedy" is an outcome such as a penalty or enforcement that
                  is ordered by a court in order to fix a problem. For example,
                  “damages” are a remedy.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What are "damages"?</p>
                <p className="small">
                  "Damages" are a legal remedy to a breach. Typically, that
                  remedy is money that is paid to a person as compensation for
                  loss or injury.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is "equitable relief"?</p>
                <p className="small">
                  "Equitable" relief can include injunctions (which prohibits a
                  specific action, like the distribution of a work), specific
                  performance (requiring that a certain action be taken),
                  rescission (the revocation of an agreement), and restitution
                  (restoration of property and/or a financial award).
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/ContractBlock/CureRemedies.jsx